import { roleFromApi } from '../types';
import type { Member, MemberDto } from '../types';

/**
 * Transforms a raw `MemberDto` (API response) into the `Member` shape used
 * by all UI components. Flattens the nested `user` object and computes the
 * `isCurrentUser` flag from the authenticated user's id.
 *
 * @param dto - Raw DTO from the server
 * @param currentUserId - ID of the currently authenticated user (`AuthUser.id`)
 * @returns Flattened `Member` ready for display
 *
 * @example
 * const members = pagedResult.items.map(dto => adaptMemberDto(dto, user.id));
 */
export function adaptMemberDto(dto: MemberDto, currentUserId?: string): Member {
  return {
    id: dto.id ?? '',
    tenantId: dto.tenantId,
    role: roleFromApi(dto.role),
    isActive: dto.isActive,
    expiresAt: dto.expiresAt,
    createdAt: dto.createdAt,
    areaId: dto.areaId,
    clientId: dto.clientId,
    userId: dto.user?.userId ?? '',
    email: dto.user?.email ?? '',
    displayName: dto.user?.displayName ?? dto.user?.email ?? '',
    avatarUrl: dto.user?.avatarUrl ?? null,
    isCurrentUser: !!currentUserId && dto.user?.userId === currentUserId,
  };
}
